module.exports = __webpack_public_path__ + "static/media/googlebadge.bd0923c8.png";